<template>
<div>
    生成二维码
</div>
</template>
<script>
export default {
    components: {
    },
    data () {
        return {
            mname: 'qrcode',
            forms: {},
        }
    },
    created () {
    },
    methods: {
    }
}
</script>

